/**
 * Created by Pali on 27/11/19.
 */

angular.module("screensApp")

  .controller("BetRadarStatsController", function ($scope, $rootScope) {
    // Show BetRadar Statistics
    $rootScope.showBetRadarStats = function (data) {
      if (!$("#betRadarStatsContainer #sr-iframe")[0]) {
        $("#betRadarStatsContainer").append('<iframe id="sr-iframe" frameborder="0" scrolling="no"></iframe>');
        SportradarIframeAPI.init($("#sr-iframe")[0]);
      }

      SportradarIframeAPI.update($("#sr-iframe")[0], {
        url: "https://s5.sir.sportradar.com/doxxbetm/" + $rootScope.config.LanguageId + "/1/season/" + data.seasonID,
      });
      $rootScope.settings.betRadarStats.actualSeasonID = data.seasonID;
      $rootScope.settings.betRadarStats.show = true;
    };

    // Hide BetRadar Statistics
    $rootScope.hideBetRadarStats = function () {
      $rootScope.settings.betRadarStats.show = false;
      $rootScope.settings.betRadarStats.actualSeasonID = false;
      if ($("#betRadarStatsContainer #sr-iframe")[0]) SportradarIframeAPI.destroy($("#sr-iframe")[0]);
    };
  });
